import { Category } from '../../categories/shared';
import { FilterValue } from './filter-value.model';

export class Filter {
  _id?: string;
  name: string = '';
  category: Category;
  values: Array<FilterValue> = [];
  position: number = 0;
  active: boolean = false;
  created: Date;
  updated: Date;
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/filters/shared/filter.model.ts